import Immutable, { Record } from 'immutable';
import PaperBasedHomeworkResult from './PaperBasedHomeworkResult';
import OnlineHomeworkResult from './OnlineHomeworkResult';
import DosRejectedComment from './DosRejectedComment';

const StudentReportSummaryRecord = Record({
  id: undefined,
  studentId: undefined,
  isPTSessionMember: undefined,
  unitSummary: undefined,
  comments: undefined,
  commentedByUserId: undefined,
  publishedByUserId: undefined,
  overWrittenByUserId: undefined,
  publishedTimeUtc: undefined,
  commentedTimeUtc: undefined,
  overWrittenTimeUtc: undefined,
  paperBasedHomeworkResult: new PaperBasedHomeworkResult(),
  dosRejectedComment: undefined,
  onlineHomeworkResult: undefined,
  status: undefined,
});

class StudentReportSummary extends StudentReportSummaryRecord { }

const reviver = ([key, val]) => {
  switch (key) {
    case 'id':
    case 'studentId':
      return [key, `${val}`]; // stringify
    case 'isPTSessionMember':
      return [key, Boolean(val)];
    case 'onlineHomeworkResult':
      return [key, OnlineHomeworkResult.create(val)];
    case 'paperBasedHomeworkResult':
      return [key, PaperBasedHomeworkResult.create(val)];
    case 'dosRejectedComment': {
      if (! val) return [key, val];
      return [key, DosRejectedComment.create(val)];
    }
    default:
      return [key, Immutable.fromJS(val)];
  }
};

StudentReportSummary.Status = Object.freeze({
  ScoresMissing: 'ScoresMissing',
  Ready: 'Ready',
  SentToDoS: 'SentToDoS',
  Completed: 'Completed',
  Published: 'Published',
  Rejected: 'Rejected',
});

StudentReportSummary.create = (data) =>
  // navigating to a future report can return an empty response.
  // the `|| {}` bit below will make this code work in that case.
  new StudentReportSummary(data || {}).mapEntries(reviver);

export default StudentReportSummary;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/model.js